import { useMutation } from 'react-query';
import { updateDemand } from 'src/services/api/demands';

function useUpdateDemand() {
  return useMutation(({ demand, data, doctorId }) => updateDemand(demand, data, { doctorId }));
}

export default useUpdateDemand;
